const base = '#25cad2';
const clearBase = '#92E4E8';
const blackBase = '#4455C2';
const darkBase = '#25cad233';

const navbar = '#053F56';

const border = { 100: '#DFDFE6', 50: '#EDEDF1' };

const mintTulip = '#C8F2F4';

const casper = '#AFB9CD';

const hawkesBlue = '#DBDFF1';

const cadetBlue = '#DBDFF1';

const snow = '#F8F9FB';

const whiteLilac = '#F8F7F9';

const aqua = '#E5F7F6';
const moonraker = '#D3D6EE';
const roseVale = '#AB454C';
const blueNavy = '#4455C2';

const nebula = '#cdd9dd';
const celestialBlue = '#4299E1';

const waterloo = {
  800: '#606073',
};

// Colors based on: https://www.colorhexa.com/4f5dba
const tealish = {
  300: '#3a4694',
  100: '#4F5DBA',
  60: '#8791d0',
};

const purple = {
  50: '#F3F5FB',
};

const tealishBlue = tealish[100];

const tealishBlueLight = '#4F5DBA33';

const error = {
  base: '#D27177',
  20: '#D2717733',
  90: '#D27177E6',
};

const warning = {
  50: error.base,
  500: '#a85a5f',
  900: '#934f53',
};

const grey = {
  800: '#071849',
  200: '#96969C',
  100: '#8484A0',
  40: '#BDC0D6',
  30: '#D3D6EE',
  20: '#C1C1Cf',
  10: '#E0E0E7',
  2: '#ffffffcc',
};

const lightWhite = '#ffffff40';

const salmon = '#FF708B';

const deepSkyBlue = '#22A6EC';

const blueViolet = '#8676FF';

const orange = '#FFBA69';

const lime = '#89E2A2';

const scroll = {
  50: 'rgba(0, 0, 0, 0.05)',
  90: 'rgba(0, 0, 0, 0.09)',
};

const text = {
  faded: grey[100],
  base: '#071850',
  dark: '#2e2e3a',
  error: error.base,
};

const table = {
  header: snow,
  footer: '#FCFCFD',
  cell: '#F1F2F7',
  faded: '#c1c1cf',
  expandRow: '#f5f6f9',
};

const link = {
  base: '#4f5dba',
  active: text.base,
  hover: `${text.base}22`,
};

const sidebarLink = {
  hover: `${text.base}11`,
  active: `${text.base}22`,
};

const close = {
  hover: snow,
  active: '#F2F3F7',
};

const navScheme = {
  500: '#053F56',
  600: '#05394d',
  700: '#043245',
};

const submitScheme = {
  500: '#4455C2',
  600: '#3d4daf',
  700: '#36449b',
};

const controlScheme = {
  500: 'transparent',
  600: grey[30],
  700: grey[40],
};

const transparentScheme = {
  500: 'transparent',
  600: '#F8F9FB',
  700: '#F2F3F7',
};

const inputScheme = {
  500: 'transparent',
  600: '#F7FAFC',
  700: '#EDF2F7',
};

const backgrounds = {
  white: '#FFF',
  default: '#F2F3F7',
  overlay: '#00000080',
  whiteAlpha: '#ffffffEB',
};

const linkWater = '#DCDFF1';

const ratings = {
  A: {
    dark: '#21A5EC',
    opacity: '#21A5EC80',
    opaqued: '#90d2f5',
    light: '#D1EBF9',
  },
  B: {
    dark: '#27CAD2',
    opacity: '#27CAD280',
    opaqued: '#93e5e9',
    light: '#D2F0F4',
  },
  C: {
    dark: '#EDC200',
    opacity: '#EDC20080',
    opaqued: '#f6e180',
    light: '#F7EFCD',
  },
  D: {
    dark: '#F49342',
    opacity: '#F4934280',
    opaqued: '#f9c9a0',
    light: '#F9E7D9',
  },
  E: {
    dark: error.base,
    opacity: '#D2717780',
    opaqued: '#e9b8bb',
    light: '#F2E1E4',
  },
  N: {
    dark: '#8484A0',
    opacity: '#8484A080',
    opaqued: '#c1c1cf',
    light: '#EDEDF1',
  },
};
const stackBarChartColorScale = [salmon, deepSkyBlue, blueViolet, lime, orange, base];

export const colors = {
  warning,
  table,
  base,
  blueNavy,
  clearBase,
  blackBase,
  darkBase,
  link,
  sidebarLink,
  close,
  navbar,
  border,
  text,
  ratings,
  navScheme,
  inputScheme,
  submitScheme,
  error,
  backgrounds,
  grey,
  tealish,
  tealishBlue,
  tealishBlueLight,
  mintTulip,
  snow,
  whiteLilac,
  aqua,
  transparentScheme,
  moonraker,
  linkWater,
  roseVale,
  scroll,
  salmon,
  deepSkyBlue,
  blueViolet,
  orange,
  lime,
  hawkesBlue,
  cadetBlue,
  nebula,
  celestialBlue,
  lightWhite,
  casper,
  controlScheme,
  stackBarChartColorScale,
  purple,
  waterloo,
};
